<template>
  <div id='floor-guide'>
    <call />
    <pop-alert />
    <top-bar title="フロアガイド">
      <template v-slot:left>
        <img src="/assets/images/icon/icon-back.svg" alt="戻る" @click="$router.go(-1)" />
      </template>
    </top-bar>
    <!-- main -->
    <main>
      <!-- nav-bot -->
      <footer-app></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="floor-guide-image">
            <div class="pinch-zoom-content ios">
              <img :src="getImgSrc(floorGuideUrl)" class="w-100" />
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Tenant } from "../plugin/mixin";
import { Common } from "../common/common.js";
import PopAlert from "../components/PopAlert.vue";
import { getShop } from "../store/firestore";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "FloorGuide",
  components: {
    'footer-app': Footer,
    PopAlert,
    TopBar
  },
  data() {
    return {
      isAndroid: Common.isAndroid(),
      floorGuideUrl: ''
    }
  },
  mixins: [Tenant],
  async created() {
    const shopData = await getShop(this.shopId);
    if (shopData) {
      this.floorGuideUrl = shopData.floorGuideImage;
    }
  },
  computed: {
    imageScale: function() {
      const scale = window.screen.width / 2250;
      return scale;
    }
  },
  mounted() {
    Common.initDom();
  }
})
</script>